<template>
    <div class="warning-message">
        <Icon name="warning" />
        {{ message }}
    </div>
</template>

<script>
import Icon from '@/components/ui/Icon';

export default {
    name: 'WarningMessage',
    components: {
        Icon,
    },
    props: {
        message: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped lang="scss">
.warning-message {
    position: relative;
    padding-left: 15px;
    font-size: 10px;
    font-style: italic;
    color: $warning-color;

    .icon {
        @include center(y);
        position: absolute;
        left: 0;
        font-size: 11px;
    }
}
</style>
